<script setup>
import { computed, ref } from 'vue'
import { useAuth } from '@/composables/useAuth.js'

const { user, updateAnalyticsConsent } = useAuth()
const saving = ref(false)
const error = ref('')
const visible = computed(() => Boolean(user.value) && user.value.cookie_consent_analytics === null)

async function persistDecision(allowed) {
  saving.value = true
  error.value = ''
  try {
    await updateAnalyticsConsent(allowed)
  } catch (e) {
    error.value = String(e)
  } finally {
    saving.value = false
  }
}
</script>

<template>
  <div v-if="visible" class="analytics-consent" role="dialog" aria-label="Analytics cookies">
    <div>
      <p class="analytics-consent__title">Analytics cookies</p>
      <p class="analytics-consent__text">
        Allow product analytics to help improve Prufa.
      </p>
      <p v-if="error" class="analytics-consent__error">{{ error }}</p>
    </div>
    <div class="analytics-consent__actions">
      <button type="button" class="btn-secondary btn-sm" :disabled="saving" @click="persistDecision(false)">Decline</button>
      <button type="button" class="btn-primary btn-sm" :disabled="saving" @click="persistDecision(true)">Allow</button>
    </div>
  </div>
</template>
